import React, {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHeart, faPlay} from '@fortawesome/free-solid-svg-icons';

const MyLikedSongs = ({ song, defaultPlatform, index, onIdsCollected }) => {
    const sJson = song.spotify_json;

    // Support both iTunes format (trackId) and old Spotify format (id)
    const isItunes = !!sJson?.trackId;

    const songId    = isItunes ? String(sJson.trackId) : sJson?.id;
    const songName  = isItunes ? sJson.trackName       : sJson?.name;
    const albumArt  = isItunes
        ? sJson.artworkUrl100?.replace('100x100', '600x600')
        : sJson?.album?.images?.[0]?.url;
    const albumName = isItunes ? sJson.collectionName  : sJson?.album?.name;
    const releaseYear = isItunes
        ? sJson.releaseDate?.substring(0, 4)
        : sJson?.album?.release_date;
    const artistDisplay = isItunes ? sJson.artistName  : sJson?.artists?.[0]?.name;

    const playUrl = defaultPlatform === 'iTunes' || isItunes
        ? (sJson?.trackViewUrl || `https://www.youtube.com/results?search_query=${encodeURIComponent(song.artist_name + ' ' + songName)}`)
        : (defaultPlatform === 'Spotify' && sJson?.external_urls?.spotify)
            ? sJson.external_urls.spotify
            : `https://www.youtube.com/results?search_query=${encodeURIComponent(song.artist_name + ' ' + songName)}`;

    const albumUrl = isItunes
        ? (sJson?.collectionViewUrl || playUrl)
        : (defaultPlatform === 'Spotify' && sJson?.album?.external_urls?.spotify)
            ? sJson.album.external_urls.spotify
            : `https://www.youtube.com/results?search_query=${encodeURIComponent(song.artist_name + ' ' + albumName)}`;

    useEffect(() => {
        if (onIdsCollected && songId) onIdsCollected(songId, sJson);
    }, [song, onIdsCollected, songId, sJson]);

    if (!sJson) return null;

    return (
        <div className="flex justify-between gap-x-6 py-5">
            <div className="flex min-w-0 gap-x-4 text-xs">
                <div className="flex-shrink-0 place-self-center text-sm">
                    {index + 1}
                </div>
                {albumArt && (
                    <div className="min-w-0 flex-none">
                        <a href={playUrl} target='_blank' rel="noreferrer"
                           className="font-medium text-white hover:text-gray-400"
                           artist={song.artist_name} song={songName} spotify={songId}>
                            <img className="Album_Icon" src={albumArt} alt={`${songName} album cover`} loading="lazy"/>
                        </a>
                    </div>
                )}
                <div className="min-w-0 flex-auto">
                    <p className="text-base xs:text-sm font-semibold leading-6 text-white">
                        <a href={playUrl} target='_blank' rel="noreferrer"
                           className="font-medium text-white hyphens-auto hover:text-gray-400"
                           artist={song.artist_name} song={songName} spotify={songId}>
                            {songName}
                        </a>
                    </p>
                    <p className="mt-1 text-sm font-semibold leading-5 text-white">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a href="#" rel="noreferrer"
                           className="font-medium text-white hyphens-auto hover:text-gray-400"
                           artist={song.artist_name} artistengname={artistDisplay} song={songName} spotify={songId}>
                            {song.artist_name}{song.artist_name !== artistDisplay ? ` (${artistDisplay})` : ''}
                        </a>
                    </p>
                    <p className="text-xs font-semibold leading-5 text-gray-400">
                        <a href={albumUrl} target='_blank' rel="noreferrer"
                           className="font-medium hyphens-auto hover:text-gray-200"
                           artist={song.artist_name} song={songName} spotify={songId}>
                            {albumName}
                        </a> ({releaseYear})
                    </p>
                </div>
            </div>
            <div className="shrink-0 flex-col items-end grid grid-cols-2 gap-2 content-start">
                <div className="text-center">
                    <p className="text-base leading-6 text-white">
                        <FontAwesomeIcon icon={faHeart} className="cursor-pointer hover:text-red-600"
                                         clicked='false' artist={song.artist_name} song={songName}
                                         spotify={songId} size='lg'/>
                    </p>
                    <p className="text-base leading-6 text-white mt-2">
                        <a href={playUrl} target='_blank' rel="noreferrer"
                           className="font-medium text-white hover:text-gray-400"
                           artist={song.artist_name} song={songName} spotify={songId}>
                            <FontAwesomeIcon icon={faPlay} size='lg'/>
                        </a>
                    </p>
                </div>
                <div>
                    <p className="text-base leading-6 text-white">
                        <span id={songId}>0</span>
                    </p>
                    <p className="text-base leading-6 text-white mt-2">
                        <span id={`c_${songId}`}>0</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MyLikedSongs;
